import React, { useEffect, useState } from "react";
import {
  BsPeopleFill,
  BsPersonLinesFill,
  BsPlusCircle,
  BsSearch,
} from "react-icons/bs";
import dummy_image from "../../assets/img/default_avatar.jpg";
import GroupListItem from "../../Component/ChatGroupBox/GroupListItem";
import ChatItemBox from "../../Component/ChatItemBox/ChatItemBox";
import MessageList from "../../Component/MessageList/MessageList";

import "./home.css";

import { useDispatch, useSelector, useStore } from "react-redux";
import { API_URL, CHAT_URL } from "../../../../config/app-config";
import {
  clearMessages,
  currentFriendMessages,
  deliveredMessage,
  getLastMessage,
  seenMessage,
  updateViewCount,
} from "../../store/actions/MessengerAction";

import axios from "axios";
import { withTranslation } from "react-i18next";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { toast } from "react-toastify";
import ChatService from "../../../../api/ChatService";
import i18n from "../../../../i18n";
import AuthService from "../../../../session/AuthService_old";
import CreateGroupModal from "../../Component/ChatGroupBox/CreateGroupModal";
import GroupMembersModal from "../../Component/ChatGroupBox/GroupMembersModal";
import GroupItemBox from "../../Component/ChatItemBox/GroupItemBox";

// Import notification sound
import notificationSound from "../../assets/notification.mp3";

function Home({ t, user, friends, socket, selectedUser, closeCallBack }) {
  const dispatch = useDispatch();
  const userInfo = user;
  const homePageRenderCount = React.useRef(0);
  homePageRenderCount.current = homePageRenderCount.current + 1;
  const store = useStore();
  
  const [openCard, setOpenCard] = React.useState(false);
  const [groupCard, setOpenGroupCard] = React.useState(false);
  const [showItemBox, setShowItemBox] = React.useState(false);
  const [currentFriend, setCurrentFriend] = React.useState(null);
  const [unseenMessageCount, setUnseenMessageCount] = React.useState([]);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [searchQueryforGroup, setSearchQueryforGroup] = React.useState("");
  const [socketMessage, setSocketMessage] = React.useState(null);
  const [initialLastMessage, setInitialLastMessage] = React.useState(null);
  const [isSelectedUserNeedstobeClear, setisSelectedUserNeedstobeClear] = React.useState(false);
  const [totalMessageCount, settotalMessageCount] = useState(0);
  const [friendsId, setFriendsId] = useState([]);
  const [initialPopUp, setInitialPopup] = useState(false);
  const [receivedMessage, setReceivedMessage] = useState(null);
  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [selectedFriends, setSelectedFriends] = useState([]);
  const [userList, setUserList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [activeTab, setActiveTab] = useState("friends");

  const [selectedGroup, setSelectedGroup] = useState(null);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [selectedGroupMembers, setSelectedGroupMembers] = useState([]);
  const [isMemberModalVisible, setIsMemberModalVisible] = useState(false);
  const [Groupmessages, setGroupmessages] = useState([]);
  const [searchQueryforGroupMessages, setSearchQueryforGroupMessages] = useState("");

  // Audio ref for notification sound
  const audioRef = React.useRef(null);
  const [enableSounds, setEnableSounds] = React.useState(true);
  const [prevTotalMessageCount, setPrevTotalMessageCount] = React.useState(0);

  const lastMessages = useSelector((state) => state.messenger?.lastMessages);
  const messages = useSelector((state) => state.messenger.messages);
  const isMessageLoading = useSelector((state) => state.messenger.isMessageLoading);

  const filteredFriends = friends;

  console.group("Memoized State : Home js Props");
  console.log("Memoized State : Rendered Count", homePageRenderCount.current);
  console.log("Memoized State : user(Home)", userInfo);
  console.log("Memoized State : friends(Home)", friends);
  console.log("Memoized State : filteredfriends(Home)", filteredFriends);
  console.log("Memoized State : friends(currentFriend)", currentFriend);
  console.log("Memoized State : friends(lastMessages)", lastMessages);
  console.log("Memoized State : friends(messages)", messages);
  console.log("Memoized state : selectedUser", selectedUser);
  console.groupEnd();

  // Initialize audio
  React.useEffect(() => {
    audioRef.current = new Audio(notificationSound);
    audioRef.current.volume = 0.3; // Set volume (0.0 to 1.0)
  }, []);

  // Function to play notification sound
  const playNotificationSound = () => {
    if (!enableSounds) return;
    
    if (audioRef.current) {
      audioRef.current.currentTime = 0; // Reset to start
      const playPromise = audioRef.current.play();
      
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.log("Audio play was prevented:", error);
          // Auto-play might be blocked by browser, user interaction required
        });
      }
    }
  };

  // Play sound when total message count increases
  React.useEffect(() => {
    if (totalMessageCount > prevTotalMessageCount && totalMessageCount > 0) {
      playNotificationSound();
    }
    setPrevTotalMessageCount(totalMessageCount);
  }, [totalMessageCount, prevTotalMessageCount]);

  const sortedLastMessage = lastMessages.sort((a, b) => {
    return a.created_at - b.created_at;
  });

  const handleSearchChange = (value) => {
    setSearchQueryforGroupMessages(value);

    const obj = {
      groupId: selectedGroup._id,
      search: value.trim(),
    };

    ChatService.getGroupMessages(obj)
      .then((response) => {
        if (response.data.status === "success") {
          setGroupmessages(response.data.data || []);
          setIsGroupModalOpen(false);
        } else {
          console.error("Message search failed:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("Search error:", error);
      });
  };

  const getGroupMessageForOpt = (selectedgroup) => {
    console.log("Fetching group messages for group:", selectedgroup);

    const obj = {
      groupId: selectedgroup._id,
      search: "",
    };

    ChatService.getGroupMessages(obj)
      .then((response) => {
        if (response.data.status === "success") {
          console.log("Messages fetched:", response.data.data);
          setGroupmessages(response.data.data);
          setIsGroupModalOpen(false);
        } else {
          console.error("Message fetch failed:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("Message fetch error:", error);
      });
  };

  const convertToFormData = (data) => {
    const formData = new FormData();

    formData.append("groupName", data.groupName);
    formData.append("description", data.description);

    if (data.groupImage && data.groupImage instanceof File) {
      formData.append("groupImage", data.groupImage);
    }

    formData.append("createdBy", JSON.stringify(data.createdBy));
    formData.append("members", JSON.stringify(data.members));

    return formData;
  };

  const handleCreateGroup = (groupData) => {
    const formData = convertToFormData(groupData);

    console.log("📦 FormData being sent:");

    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    ChatService.createGroupChat(formData)
      .then((response) => {
        console.log("Group created successfully:", response.data);
        let list = [...groupList, response.data.data]
        setGroupList(list);
        setIsGroupModalOpen(false);
      })
      .catch((error) => {
        console.error("Group creation failed:", error);
      });
  };

  const getGroupByMemberId = () => {
    console.log("Fetching group by member ID:", user.uId);

    let obj = {
      id: user.uId,
      search: searchQueryforGroup,
    };

    ChatService.getGroupsByMemberId(obj)
      .then((response) => {
        console.log("Fetched group:", response.data);

        if (response?.data?.data) {
          setGroupList(response.data.data || []);
        }
      })
      .catch((error) => {
        console.error("Error fetching group:", error);
      });
  };

  const handleChatListBoxCloseGroup = () => {
    setIsChatOpen(false);
    setSelectedGroup(null);
  };

  const sortedfriendsListBasedOnNewMessage = filteredFriends.sort((a, b) => {
    console.log("Started Sorting");
    const findlastMessageIndex = (a) =>
      sortedLastMessage.findIndex((message) => {
        return (
          +message.senderId === a?.userId || +message.receiverId === a?.userId
        );
      });

    const firstDataCreatedAt =
      findlastMessageIndex(a) === -1
        ? null
        : sortedLastMessage[findlastMessageIndex(a)].created_at;
    const secondDataCreateAt =
      findlastMessageIndex(b) === -1
        ? null
        : sortedLastMessage[findlastMessageIndex(b)].created_at;

    return new Date(secondDataCreateAt) - new Date(firstDataCreatedAt);
  });

  const handleChatListBoxOpen = (friend, id) => {
    console.log("handle-click", id);
    setCurrentFriend(friend);
    if (id) {
      dispatch(
        updateViewCount(id?.messageId ? id.messageId : id?._id, friend.userId)
      );
    }
  };

  const handleChatListBoxClose = () => {
    console.log("CLOSE ENTERING");
    dispatch({
      type: "CHAT_POPUP_ACTION",
      payload: null,
    });
    dispatch(clearMessages());
    setShowItemBox(false);
    setCurrentFriend(null);
    setUnseenMessageCount([]);
    if (selectedUser) {
      setisSelectedUserNeedstobeClear(true);
    }
    console.log("CLOSE CLOSED");
  };

  const showCardBody = () => {
    setSearchQuery("");
    setOpenCard(!openCard);
  };

  const showCardGroupBody = () => {
    setSearchQuery("");
    setOpenGroupCard(!groupCard);
    getGroupByMemberId();
  };

  React.useEffect(() => {
    if (isSelectedUserNeedstobeClear) {
      console.log("Memoized Stated : Selected Used Cleared ");
      closeCallBack();
    }
  }, [isSelectedUserNeedstobeClear]);

  React.useEffect(() => {
    let langValue = AuthService.getCommonLanguages();
    i18n.changeLanguage(langValue);
    const friendsId = filteredFriends.map((item) => item.userId);
    setFriendsId(friendsId ? friendsId : []);
  }, []);

  React.useEffect(() => {
    if (selectedUser) {
      console.log("Memoized State : selected Used", selectedUser);
      setCurrentFriend(selectedUser);
    }
  }, [selectedUser]);

  useEffect(() => {
    console.log("Memoized State: going to dispatch friends");

    let formValues = {
      name: "",
    };

    ChatService.getUserForGroupChat(formValues)
      .then((response) => {
        console.log("Fetched Users:", response.data.data);
        if (response?.data?.data) {
          console.log("Fetched Users:", response.data.data);
          setUserList(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  }, []);

  React.useEffect(() => {
    dispatch(getLastMessage(userInfo?.uId)).then(() => {
      const currentUpdateState = store.getState();
      setInitialLastMessage(currentUpdateState?.messenger?.lastMessages);
    });
  }, []);

  React.useEffect(() => {
    if (currentFriend) {
      console.log("Memoized State : going to dispatch message", currentFriend);
      dispatch(currentFriendMessages(userInfo?.uId, currentFriend?.userId));
    }
  }, [currentFriend?.userId]);

  React.useEffect(() => {
    console.log("Memoized State : isMessage Loading changed", isMessageLoading);
    if (!isMessageLoading) {
      setShowItemBox(true);
      setUnseenMessageCount([]);
    }
  }, [isMessageLoading]);

  React.useEffect(() => {
    socket.current.emit("loginedUsers", userInfo);
  }, []);

  useEffect(() => {
    const handleMessage = (data) => {
      console.log("Memoized State : getting Message", data);
      dispatch({
        type: "UPDATE_FRIEND_MESSAGE",
        payload: data,
      });
      dispatch({
        type: "UPDATE_RECEIVE_MESSAGE",
        payload: data,
      });
      setReceivedMessage(data);
    };

    const handleSeenMessageResponse = (data) => {
      console.log("message-seen", data);
      dispatch({
        type: "MESSAGE_SEEN",
        payload: data,
      });
    };

    const handleDeliveredMessageResponse = (data) => {
      console.log("message_delivered", data);
      dispatch({
        type: "MESSAGE_DELIVERED",
        payload: data,
      });
    };

    socket.current.on("getMessage", handleMessage);
    socket.current.on("seenMessageResponse", handleSeenMessageResponse);
    socket.current.on("deliveredMessageResponse", handleDeliveredMessageResponse);

    return () => {
      socket.current.off("getMessage", handleMessage);
      socket.current.off("seenMessageResponse", handleSeenMessageResponse);
      socket.current.off("deliveredMessageResponse", handleDeliveredMessageResponse);
    };
  }, []);

  useEffect(() => {
    console.log("%c VIEW MESSAGE : ->", "color:orange", receivedMessage);
    console.log("currentFriend", currentFriend)
    if (receivedMessage && currentFriend) {
      console.log("%c ENTERING DISPATCHING USEEFFECT : ->", "color:orange", receivedMessage);
      if (
        +receivedMessage.senderId === currentFriend?.userId &&
        +receivedMessage.receiverId === userInfo?.uId
      ) {
        console.log("seen-message-update");
        dispatch(seenMessage(receivedMessage));
        socket.current.emit("seenMessage", receivedMessage);
      }
    }
    console.log("selectedGroup", selectedGroup);
    if (receivedMessage && selectedGroup && selectedGroup._id === receivedMessage?.groupId) {
      console.log("receivedMessage-groupId", receivedMessage);
      setGroupmessages((prevMessages) => [...prevMessages, receivedMessage]);
    }
  }, [receivedMessage, selectedGroup]);

  React.useEffect(() => {
    if (socketMessage) {
      console.log("%c ENTERING DELIVERY USEEFFECT : ->", "color:orange", socketMessage);
      dispatch(deliveredMessage(socketMessage));
      dispatch({
        type: "UPDATE_FRIEND_MESSAGE",
        payload: socketMessage,
      });
    }
  }, [socketMessage]);

  useEffect(() => {
    console.log("friendsId", friendsId);
    const data = lastMessages.reduce((result, data) => {
      if (
        data?.unseenCount &&
        +data?.receiverId !== +data?.senderId &&
        (friendsId.includes(+data.senderId) || friendsId.includes(+data.receiverId))
      ) {
        result = result + data?.unseenCount;
      }
      return result;
    }, 0);
    console.log("data", data);
    console.log("message-lastMessages", lastMessages);

    settotalMessageCount(data);
    if (data && !initialPopUp) {
      console.log("open-popup", initialPopUp);
      setInitialPopup(true);
      setSearchQuery("");
      setOpenCard(true);
    }
  }, [lastMessages, friendsId]);

  const updateGrouMessageData = (data) => {
    console.log("updateGrouMessageData", data);
    socket.current.emit("sendMessage", data);
    let list = [...Groupmessages, data]
    console.log("updateGrouMessageData", list);
    setGroupmessages(list);
    console.log("Updated group messages:", groupList);
  }

  const handleGroupUpdate = async (formData) => {
    try {
      const response = await axios.post(`${CHAT_URL}api/editGroup`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Group updated successfully!");
      setIsMemberModalVisible(false);
    } catch (err) {
      toast.error("Failed to update group.");
      console.error("Edit group error:", err);
    }
  };

  return (
    <div className="home-container">
      <div className="chat-card">
        {window.matchMedia("(min-width:739px)").matches === true ? (
          <>
            <div className="chat-card-header" onClick={showCardBody}>
              <div className="chat-header-content">
                <div className="user-avatar-container">
                  <img
                    src={
                      userInfo.profile_uuid
                        ? `${API_URL}auth/image/${userInfo?.profile_uuid}`
                        : dummy_image
                    }
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = dummy_image;
                    }}
                    alt="Profile"
                    className="user-avatar"
                  />
                  <div className="user-info">
                    {/* <span className="username">{userInfo?.dName || "User"}</span> */}
                    <span className="chat-label">{t("Chat")}</span>
                  </div>
                </div>
                <div className="header-actions">
                  {totalMessageCount > 0 && (
                    <div className="notification-badge">
                      <IoChatboxEllipsesOutline className="chat-icon" />
                      <span className="notification-count">{totalMessageCount}</span>
                    </div>
                  )}
                  <div className="toggle-icon" onClick={showCardBody}>
                    {openCard ? <MdKeyboardArrowDown /> : <MdKeyboardArrowUp />}
                  </div>
                </div>
              </div>
            </div>
            
            <div className={`chat-card-body ${openCard ? "expanded" : "collapsed"}`}>
              {/* Tab Navigation */}
              <div className="chat-tab-navigation">
                <div 
                  className={`tab-item ${activeTab === "friends" ? "active" : ""}`}
                  onClick={() => setActiveTab("friends")}
                >
                  <BsPersonLinesFill className="tab-icon" />
                  <span>Chats</span>
                </div>
                <div 
                  className={`tab-item ${activeTab === "groups" ? "active" : ""}`}
                  onClick={() => {
                    setActiveTab("groups");
                    showCardGroupBody();
                  }}
                >
                  <BsPeopleFill className="tab-icon" />
                  <span>Groups</span>
                </div>
              </div>

              {/* Search Section */}
              <div className="search-section">
                <div className="search-container">
                  {/* <BsSearch className="search-icon" /> */}
                  <input
                    type="text"
                    value={activeTab === "groups" ? searchQueryforGroup : searchQuery}
                    placeholder={activeTab === "groups" ? "Search groups..." : "Search contacts..."}
                    onChange={(e) => 
                      activeTab === "groups" 
                        ? setSearchQueryforGroup(e.target.value)
                        : setSearchQuery(e.target.value)
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && activeTab === "groups") {
                        getGroupByMemberId();
                      }
                    }}
                    className="search-input"
                  />
                </div>
              </div>

              {/* Content Section */}
              <div className="chat-content-section">
                {activeTab === "groups" ? (
                  <>
                    <div className="groups-container">
                      <div className="groups-header">
                        <h3>Your Groups</h3>
                        <BsPlusCircle 
                          className="create-group-btn"
                          onClick={() => setIsGroupModalOpen(true)}
                          title="Create New Group"
                        />
                      </div>
                      <div className="groups-list">
                        {groupList.map((group) => (
                          <GroupListItem
                            key={group.groupId}
                            group={group}
                            onOpenChat={(group) => {
                              console.log("Open chat with group:", group);
                              setSelectedGroup(group);
                              setIsChatOpen(true);
                              getGroupMessageForOpt(group)
                            }}
                            onShowGroupMembers={(group) => {
                              setSelectedGroup(group);
                              setSelectedGroupMembers(group.members || []);
                              setIsMemberModalVisible(true);
                            }}
                          />
                        ))}
                        {groupList.length === 0 && (
                          <div className="empty-state">
                            <BsPeopleFill size={48} className="empty-icon" />
                            <p>No groups yet</p>
                            <button 
                              className="create-first-group-btn"
                              onClick={() => setIsGroupModalOpen(true)}
                            >
                              Create Your First Group
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="contacts-container">
                      <div className="contacts-header">
                        <h3>Recent Chats</h3>
                        <span className="contacts-count">{filteredFriends.length} contacts</span>
                      </div>
                      <div className="contacts-list">
                        {filteredFriends && filteredFriends.length > 0 ? (
                          filteredFriends
                            .filter((friend) =>
                              searchQuery === ""
                                ? friend
                                : friend?.userName.toLowerCase().includes(searchQuery.toLowerCase())
                            )
                            .map((friend) => (
                              <MessageList
                                key={friend.userId}
                                userId={userInfo.uId}
                                friend={friend}
                                handleChatList={handleChatListBoxOpen}
                                unseenMessageCount={unseenMessageCount}
                                allFriends={filteredFriends}
                                initialLastMessage={initialLastMessage ? initialLastMessage : []}
                                lastMessage={lastMessages}
                                setUnseenMessageCount={setUnseenMessageCount}
                                isCurrentFriendAvailiable={currentFriend}
                              />
                            ))
                        ) : (
                          <div className="empty-state">
                            <BsPersonLinesFill size={48} className="empty-icon" />
                            <p>No contacts available</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </>
        ) : (
          // Mobile View (unchanged functionality, enhanced styling)
          <>
            <div className="chat-card-header mobile">
              <div className="chat-header-content">
                <div className="user-avatar-container">
                  <img
                    src={userInfo?.uPhoto ? `data:image/jpeg;base64,${userInfo?.uPhoto}` : dummy_image}
                    alt="Profile"
                    className="user-avatar"
                  />
                  <span className="chat-label">{t("Chat")}</span>
                </div>
                <div className="toggle-icon" onClick={showCardBody}>
                  <MdKeyboardArrowUp />
                </div>
              </div>
            </div>
            <div className="chat-card-body mobile expanded">
              <div className="search-section mobile">
                <div className="search-container">
                  <BsSearch className="search-icon" />
                  <input
                    type="text"
                    value={searchQuery}
                    placeholder="Search contacts..."
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="search-input"
                  />
                </div>
              </div>
              <div className="contacts-list mobile">
                {filteredFriends && filteredFriends.length > 0 &&
                  sortedfriendsListBasedOnNewMessage
                    .filter((friend) =>
                      searchQuery === ""
                        ? friend
                        : friend?.userName.toLowerCase().includes(searchQuery.toLowerCase())
                    )
                    .map((friend) => (
                      <MessageList
                        key={friend.userId}
                        friend={friend}
                        userId={userInfo.uId}
                        handleChatList={handleChatListBoxOpen}
                        unseenMessageCount={unseenMessageCount}
                        allFriends={filteredFriends}
                        initialLastMessage={initialLastMessage ? initialLastMessage : []}
                        lastMessage={lastMessages}
                        setUnseenMessageCount={setUnseenMessageCount}
                        isCurrentFriendAvailiable={currentFriend}
                      />
                    ))
                }
              </div>
            </div>
          </>
        )}
      </div>

      {/* Chat Windows */}
      {showItemBox && currentFriend && (
        <ChatItemBox
          handleChatListBoxClose={handleChatListBoxClose}
          currentFriend={currentFriend}
          messages={messages}
          user={userInfo}
          socket={socket}
          isMessageLoading={isMessageLoading}
        />
      )}

      {isChatOpen && (
        <GroupItemBox
          isChatOpen={isChatOpen}
          handleChatListBoxClose={handleChatListBoxCloseGroup}
          selectedGroup={selectedGroup}
          user={userInfo}
          socket={socket}
          selectedGroupMembers={selectedGroupMembers}
          messages={Groupmessages}
          updateGrouMessageData={updateGrouMessageData}
          onSearchChange={handleSearchChange}
        />
      )}

      {/* Modals */}
      <CreateGroupModal
        isGroupModalOpen={isGroupModalOpen}
        setIsGroupModalOpen={setIsGroupModalOpen}
        userList={userList}
        handleCreateGroup={handleCreateGroup}
        createBy={userInfo}
      />

      <GroupMembersModal
        visible={isMemberModalVisible}
        onClose={() => setIsMemberModalVisible(false)}
        group={selectedGroup}
        onSave={handleGroupUpdate}
        userList={userList}
      />
    </div>
  );
}

export default React.memo(withTranslation()(Home));